import { ReactNode } from 'react'
import { motion } from 'framer-motion'
import { cx } from '@/utils/strings'
import { isPrint } from '@/utils/print'

type CollapsibleProps = {
  className?: string
  children: ReactNode
  isOpen?: boolean
  onAnimationComplete?: (isOpen: boolean) => void
  disableAnimation?: boolean
}

export default function Collapsible({
  className,
  children,
  isOpen,
  onAnimationComplete,
  disableAnimation = false,
}: CollapsibleProps) {
  if (isPrint()) {
    return <div className={className}>{children}</div>
  }
  return (
    <motion.div
      className={cx(className, 'overflow-hidden')}
      initial={false}
      exit="collapsed"
      animate={isOpen ? 'open' : 'collapsed'}
      variants={{
        open: {
          opacity: 1,
          height: 'auto',
          transition: {
            ease: 'anticipate',
            height: { duration: disableAnimation ? 0 : 0.3 },
            opacity: { duration: disableAnimation ? 0 : 0.2 },
          },
          visibility: 'visible',
        },
        collapsed: {
          opacity: 0,
          height: 0,
          transition: {
            ease: 'anticipate',
            height: { duration: disableAnimation ? 0 : 0.2 },
            opacity: { duration: disableAnimation ? 0 : 0.1 },
          },
          transitionEnd: {
            visibility: 'hidden',
          },
        },
      }}
      onAnimationComplete={() => {
        onAnimationComplete?.(!!isOpen)
      }}
    >
      {children}
    </motion.div>
  )
}
